import React from 'react';
import type { useCategoryFilterSort } from '@ui-rocco/hooks/use-category-filter-sort';
import type { SearchSuggestionGroup } from '@rocco/ui/search/view-models/search-suggestion';
import { MobileSearchPageRecentlySearched } from './MobileSearchPageRecentlySearched';
import { MobileSearchPageSuggestedGroups } from './MobileSearchPageSuggestedGroups';
import { SearchResultPageTilesGrid } from './SearchResultPageTilesGrid';
import { MobileSearchTrending } from './MobileSearchTrending';

type MobileSearchPageView = 'results' | 'recentlySearched' | 'suggestions';

interface SearchPageContentSectionsMobileProps {
    view: MobileSearchPageView;
    filterSortProps: ReturnType<typeof useCategoryFilterSort>;
    suggestionGroups: SearchSuggestionGroup[];
    inputSearchQuery: string;
    isLoading: boolean;
}

/**
 * Renders the content sections for the mobile view of the search page.
 * Switches between recently searched, suggestions, and results views.
 */
export const SearchPageContentSectionsMobile: React.FC<
    SearchPageContentSectionsMobileProps
> = ({
    view,
    filterSortProps,
    suggestionGroups,
    inputSearchQuery,
    isLoading,
}) => {
    return (
        <>
            {view === 'recentlySearched' && (
                <>
                    <MobileSearchTrending context="page" />
                    <MobileSearchPageRecentlySearched />
                </>
            )}
            {view === 'suggestions' &&
                suggestionGroups[0] &&
                suggestionGroups
                    .filter((group) => group.options.length > 0)
                    .map((group) => (
                        <MobileSearchPageSuggestedGroups
                            key={group.type}
                            query={inputSearchQuery}
                            group={group}
                        />
                    ))}
            {view === 'results' && (
                <SearchResultPageTilesGrid
                    {...filterSortProps}
                    isLoading={isLoading}
                />
            )}
        </>
    );
};
